import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CircularProgress } from '@mui/material';
import { fetchWithToken } from '../../../api/apiutils'; 

const GetLinksModal = ({ open, onClose, analysisId }) => {
  const [loading, setLoading] = useState(true);
  const [logData, setLogData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLogDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchWithToken(`/api/lots/analysis/details?Id=${analysisId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch log details');
        }
        const result = await response.json();
        setLogData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (open && analysisId) {
      fetchLogDetails();
    }
  }, [open, analysisId]);

  if (loading) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </Box>
      </Modal>
    );
  }

  if (error) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <Typography color="error">{error}</Typography>
        </Box>
      </Modal>
    );
  }

  const textSearchResult = logData?.textSearchResult || {};
  const logs = logData?.logs || [];

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ p: 4, backgroundColor: 'white', maxWidth: '80%', maxHeight: '80vh', overflowY: 'auto', margin: 'auto', mt: 10, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Лог анализа
        </Typography>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Дата ответа (ссылки)</TableCell>
                <TableCell>Уникальность</TableCell>
                <TableCell>Ссылки</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{textSearchResult.dateCheck ? new Date(textSearchResult.dateCheck).toLocaleString() : ''}</TableCell>
                <TableCell>{textSearchResult.unique ?? ''}</TableCell>
                <TableCell>
                  {textSearchResult.urls && textSearchResult.urls.length > 0 ? (
                    textSearchResult.urls.map((link, i) => (
                      <div key={i}>
                        <a href={link.url} target="_blank" rel="noopener noreferrer">{link.url}</a>
                        <br />
                        Статус: {link.result}
                        {link.error && <div>Ошибка: {link.error}</div>}
                      </div>
                    ))
                  ) : (
                    ''
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default GetLinksModal;
